import * as _ from 'lodash';

import { ICalendarStateAction } from '@adage/ace-calendar';
import { ExtendedActionType } from "../actions/index";
import { InputOption } from "../../classes";
import { IFilter } from "../actions/filter-actions";

export interface IFilterState {
    dropdownOptions: { [dropdownName: string]: string };
}

export const defaultFilterState: IFilterState = {
    dropdownOptions: {}
}

export default function filterReducer(state: IFilterState = defaultFilterState, action: ICalendarStateAction) {
    switch (action.type) {
        case ExtendedActionType.ClearSelectedFilterOptions: {
            return _.assign({}, state, { dropdownOptions: {} }) as IFilterState;
        }
        case ExtendedActionType.SelectFilterOption: {
            const filter: IFilter = action.value as IFilter;
            let newFilter = _.assign({}, state.dropdownOptions) as { [dropdownName: string]: string };

            newFilter[filter.filterKey] = filter.chosenValue;

            return _.assign({}, state, { dropdownOptions: newFilter });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/redux/reducers/filter-reducer.ts